import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=5188f812&scoped=true"
import script from "./StoreInfo.vue?vue&type=script&lang=js"
export * from "./StoreInfo.vue?vue&type=script&lang=js"
import style0 from "./StoreInfo.vue?vue&type=style&index=0&id=5188f812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188f812",
  null
  
)

export default component.exports